module.exports = __webpack_public_path__ + "static/img/ic_reject.c5f3d466.png";